import { EventName, createComponent } from '@lit/react';
import { BlocksFileUpload } from 'blocks-nextjs/blocks-web-components/components/file-upload/file-upload';
import { BlocksFileActionEvent, BlocksFileAddEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';

export const CatFileUpload = createComponent({
  react: React,
  tagName: 'cat-file-upload',
  elementClass: BlocksFileUpload,
  events: {
    onBlFileAdd: 'bl-file-add' as EventName<BlocksFileAddEvent>,
    onBlFileAction: 'bl-file-action' as EventName<BlocksFileActionEvent>
  }
});
